<script>
import { mapActions, mapGetters } from "vuex";
import GameDataManager from "./GameDataManager";
import { GAME_TYPE } from "@/constants";
import { toDateWithOffset } from "vue-chess-shared/utils/date-helper";
import { serverTimestamp } from "@/utils/firebase-helper";

export default {
  name: "GameDataManagerLocal",

  extends: GameDataManager,

  watch: {
    match() {
      if (!this.match || !this.moves) return;
      this.isReady = true;
    },

    moves() {
      if (!this.match || !this.moves) return;
      this.isReady = true;
    },
  },

  computed: {
    ...mapGetters({
      getMoves: "getLocalMovesByMatchId",
      getMatch: "getLocalMatchById",
    }),

    match() {
      return this.getMatch(this.matchId) || {};
    },

    moves() {
      return this.getMoves(this.matchId) || [];
    },
  },

  methods: {
    ...mapActions({
      addLocalMove: "addLocalMove",
      updateMatchUserAction: "updateMatchUserAction",
      updateLastMoveUserAction: "updateLastMoveUserAction",
    }),

    createMove(moveData) {
      this.addLocalMove({
        matchId: this.matchId,
        moveData: {
          ...moveData,
          received: this.gameType === GAME_TYPE.PvAI,
          receivedAt:
            this.gameType === GAME_TYPE.PvAI ? serverTimestamp() : null,
        },
      });
    },

    abort() {
      if (!this.playerColor) return;
      if (this.match.result) return;

      this.updateMatchUserAction({
        matchId: this.matchId,
        userAction: {
          abortedByColor: this.playerColor,
          abortedAt: toDateWithOffset(0),
        },
      });
    },

    resign() {
      if (!this.playerColor) return;
      if (this.match.result) return;

      this.updateMatchUserAction({
        matchId: this.matchId,
        userAction: {
          resignedByColor: this.playerColor,
          resignedAt: toDateWithOffset(0),
        },
      });
    },

    requestDraw() {
      if (this.match.result) return;
      if (!this.lastMove) return;

      const { userAction } = this.lastMove;
      if (userAction && userAction.drawRequestedAt) return;

      this.updateLastMoveUserAction({
        matchId: this.matchId,
        userAction: {
          drawRequestedByColor: this.playerColor,
          drawRequestedAt: toDateWithOffset(0),
        },
      });
    },

    denyDraw() {
      if (this.match.result) return;
      if (!this.lastMove) return;

      const { userAction } = this.lastMove;

      // no one request, invalid action
      if (!userAction || !userAction.drawRequestedAt) return;

      if (userAction.drawRespondedAt) return;

      this.updateLastMoveUserAction({
        matchId: this.matchId,
        userAction: {
          drawResponse: "deny",
          drawRespondedAt: toDateWithOffset(0),
        },
      });
    },

    acceptDraw() {
      if (this.match.result) return;
      if (!this.lastMove) return;

      const { userAction } = this.lastMove;

      // no one request, invalid action
      if (!userAction || !userAction.drawRequestedAt) return;

      if (userAction.drawRespondedAt) return;

      this.updateLastMoveUserAction({
        matchId: this.matchId,
        userAction: {
          drawResponse: "accept",
          drawRespondedAt: toDateWithOffset(0),
        },
      });
    },
  },
};
</script>
